import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchMovimentacaoReport } from '../actions/movimentacaoActions'
import { DateTime } from 'luxon'
import { Datepicker, Loader } from 'modules/shared'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import Select from 'react-select'
import { dateIdToDate, numFormat } from 'helpers'

const { SearchBar } = Search

const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return <button style={{ borderRadius: 0 }} className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
}

class Movimentacao extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dateIni: DateTime.local().minus({ days: 1 }).startOf('month').toJSDate(),
            dateEnd: DateTime.local().minus({ days: 1 }).endOf('month').toJSDate(),
            filteredCompanies: [],
        }
    }

    componentDidMount() {
        if (!this.props.movState.dados)
            this.props.fetchMovimentacaoReport(this.state)
    }

    updateDates(dates) {
        if (dates.length >= 1 && (DateTime.fromJSDate(this.state.dateIni).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[0]).toFormat('yyyyMMdd') || DateTime.fromJSDate(this.state.dateEnd).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[1]).toFormat('yyyyMMdd'))) {
            if (dates.length === 1)
                this.setState({ dateIni: dates[0], dateEnd: dates[0] })
            else
                this.setState({ dateIni: dates[0], dateEnd: dates[1] })
        }
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.movState.dados.empresas.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }

    render() {

        let { loading, dados } = this.props.movState

        if (loading)
            return <Loader />

        let empresas = dados && dados.empresas && dados.empresas.length ? dados.empresas : []
        const options = empresas.map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }))

        const columns = [
            { dataField: 'index', text: 'index', sort: false, hidden: true, csvExport: false },
            { dataField: 'data', text: 'Data', sort: true, formatter: dateIdToDate, csvFormatter: dateIdToDate },
            { dataField: 'nomeEmpresa', text: 'Empresa', sort: true },
            { dataField: 'mapa', text: 'Mapa resumo', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
            { dataField: 'vDet', text: 'Venda det.', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
            { dataField: 'dVista', text: 'Desc. à vista', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
            { dataField: 'dif1', text: 'Mapa - Venda det.', sort: false, formatter: (cell, row) => numFormat(Math.abs((row.mapa - row.vDet) - row.dVista), 2), csvFormatter: (cell, row) => numFormat(Math.abs((row.mapa - row.vDet) - row.dVista), 2) },
            { dataField: 'vGer', text: 'Venda gerencial', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
            { dataField: 'red', text: 'Redução Z', sort: true, formatter: (cell, row) => numFormat(cell + row.redDP, 2), csvFormatter: (cell, row) => numFormat(cell + row.redDP, 2) },
            { dataField: 'dif2', text: 'Venda ger. - Redução Z', sort: false, formatter: (cell, row) => numFormat(Math.abs(row.vGer - (row.red + row.redDP)), 2), csvFormatter: (cell, row) => numFormat(Math.abs(row.vGer - (row.red + row.redDP)), 2) }
        ]

        const toolkitProps = { keyField: 'index', data: dados ? dados.report || [] : [], columns, search: { searchFormatted: true }, exportCSV: true }

        return (
            <div className="container-fluid">

                <div className="row mb-4">

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={options}
                            defaultValue={empresas.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }))}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterCompanies(value)}
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Datepicker
                            defaultDate={[this.state.dateIni, this.state.dateEnd]}
                            onChange={dates => this.updateDates(dates)}
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.props.fetchMovimentacaoReport(this.state)} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt pr-2"></i>
                            Filtrar
                        </button>
                    </div>

                </div>

                <div className="row mr-2">

                    <div className="col">

                        <ToolkitProvider {...toolkitProps}>
                            {props =>
                                <Fragment>
                                    <div className="row mb-3">
                                        <div className="col col-sm-4 col-md-3">
                                            <SearchBar delay={250} placeholder="Pesquisar na tabela..." className="form-control-sm" {...props.searchProps} />
                                        </div>
                                        <div className="col">
                                            <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col" style={{ fontSize: '.8rem' }}>
                                            <p className="mb-0"><strong>Total Mapa resumo:</strong> {numFormat(props.baseProps.data.map(d => d.mapa).reduce((acc, v) => acc + v, 0), 2 , true)}</p>
                                            <p className="mb-0"><strong>Total Venda det.:</strong> {numFormat(props.baseProps.data.map(d => d.vDet).reduce((acc, v) => acc + v, 0), 2 , true)}</p>
                                            <p className="mb-0"><strong>Total Venda ger.:</strong> {numFormat(props.baseProps.data.map(d => d.vGer).reduce((acc, v) => acc + v, 0), 2 , true)}</p>
                                            <p className="mb-2"><strong>Total Redução:</strong> {numFormat(props.baseProps.data.map(d => d.red + d.redDP).reduce((acc, v) => acc + v, 0), 2 , true)}</p>
                                        </div>
                                    </div>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        hover
                                        defaultSorted={[{ dataField: 'data', order: 'asc' }]}
                                        classes="table-sm table-font-size"
                                        wrapperClasses="table-responsive"
                                        pagination={paginationFactory({ sizePerPage: 50, sizePerPageList: [50, 100, 150, 200], showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                                        noDataIndication={'Sem dados'}
                                    />
                                </Fragment>
                            }
                        </ToolkitProvider>

                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = store => ({ movState: store.movReportState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchMovimentacaoReport }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Movimentacao)